import React, { useEffect, useMemo, useState } from "react";
import Breadcrumbs from "../../Breadcrumbs";
import Select from "react-select";
import InsiteModal from "./InsiteModal";

const socialMediaOptions = [
  {
    value: "instagram",
    label: "Instagram",
  },
  {
    value: "youtube",
    label: "YouTube",
  },
  {
    value: "tiktok",
    label: "TikTok",
  },
];
const tableRows = [
  {
    id: 1,
    username: "cristiano",
    name: "Cristiano Ronaldo",
    date: "December 20, 2025",
    time: "1:12 PM",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/8/8c/Cristiano_Ronaldo_2018.jpg",
  },
  {
    id: 2,
    username: "therock",
    name: "Dwayne Johnson",
    date: "December 9, 2025",
    time: "10:13 PM",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Dwayne_The_Rock_Johnson_2009_street_portrait.jpg/640px-Dwayne_The_Rock_Johnson_2009_street_portrait.jpg",
  },
  {
    id: 3,
    username: "therock",
    name: "Dwayne Johnson",
    date: "December 9, 2025",
    time: "10:13 PM",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Dwayne_The_Rock_Johnson_2009_street_portrait.jpg/640px-Dwayne_The_Rock_Johnson_2009_street_portrait.jpg",
  },
  {
    id: 4,
    username: "therock",
    name: "Dwayne Johnson",
    date: "December 9, 2025",
    time: "10:13 PM",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Dwayne_The_Rock_Johnson_2009_street_portrait.jpg/640px-Dwayne_The_Rock_Johnson_2009_street_portrait.jpg",
  },
  {
    id: 5,
    username: "therock",
    name: "Dwayne Johnson",
    date: "December 9, 2025",
    time: "10:13 PM",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Dwayne_The_Rock_Johnson_2009_street_portrait.jpg/640px-Dwayne_The_Rock_Johnson_2009_street_portrait.jpg",
  },
  {
    id: 6,
    username: "therock",
    name: "Dwayne Johnson",
    date: "December 9, 2025",
    time: "10:13 PM",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Dwayne_The_Rock_Johnson_2009_street_portrait.jpg/640px-Dwayne_The_Rock_Johnson_2009_street_portrait.jpg",
  },
  {
    id: 7,
    username: "therock",
    name: "Dwayne Johnson",
    date: "December 9, 2025",
    time: "10:13 PM",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Dwayne_The_Rock_Johnson_2009_street_portrait.jpg/640px-Dwayne_The_Rock_Johnson_2009_street_portrait.jpg",
  },
  {
    id: 8,
    username: "therock",
    name: "Dwayne Johnson",
    date: "December 9, 2025",
    time: "10:13 PM",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Dwayne_The_Rock_Johnson_2009_street_portrait.jpg/640px-Dwayne_The_Rock_Johnson_2009_street_portrait.jpg",
  },
  {
    id: 9,
    username: "therock",
    name: "Dwayne Johnson",
    date: "December 9, 2025",
    time: "10:13 PM",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Dwayne_The_Rock_Johnson_2009_street_portrait.jpg/640px-Dwayne_The_Rock_Johnson_2009_street_portrait.jpg",
  }, {
    id: 10,
    username: "therock",
    name: "Dwayne Johnson",
    date: "December 9, 2025",
    time: "10:13 PM",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Dwayne_The_Rock_Johnson_2009_street_portrait.jpg/640px-Dwayne_The_Rock_Johnson_2009_street_portrait.jpg",
  }, {
    id: 11,
    username: "therock",
    name: "Dwayne Johnson",
    date: "December 9, 2025",
    time: "10:13 PM",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Dwayne_The_Rock_Johnson_2009_street_portrait.jpg/640px-Dwayne_The_Rock_Johnson_2009_street_portrait.jpg",
  },
];
const InfluencerInsights = () => {
  const [formData, setFormData] = useState({
    socialMedia: null,
    searchValue: "",
    socialPlatform: null,
    selectedRows: [],
  });

  const [currentPage, setCurrentPage] = useState(1);
  // const [clientsPerPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");

  const [showRemarksModal, setShowRemarksModal] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null);


  /* ---------- PAGINATION LOGIC ---------- */

  const filteredRows = useMemo(() => {
    return tableRows.filter(
      (row) =>
        row.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);


  const totalItems = filteredRows.length;
  const totalPages = Math.ceil(totalItems / entriesPerPage);

  const indexOfLastItem = currentPage * entriesPerPage;
  const indexOfFirstItem = indexOfLastItem - entriesPerPage;
  const currentRows = filteredRows.slice(indexOfFirstItem, indexOfLastItem);

  const handleChange = (field, value, meta = {}) => {
    // react-select
    if (value && !value.target && field !== "checkbox") {
      setFormData((prev) => ({ ...prev, [field]: value }));
      return;
    }

    // input / textarea
    if (value?.target && field !== "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [field]: value.target.value,
      }));
      return;
    }

    if (field === "checkbox") {
      const { type, id, checked } = meta;

      setFormData((prev) => {
        if (type === "all") {
          return {
            ...prev,
            selectedRows: checked
              ? currentRows.map((r) => r.id)
              : [],
          };
        }

        if (type === "row") {
          return {
            ...prev,
            selectedRows: checked
              ? [...prev.selectedRows, id]
              : prev.selectedRows.filter((rowId) => rowId !== id),
          };
        }

        return prev;
      });
    }
  };


  const handleSearch = () => {
    console.log(" ====================================");
    console.log(formData.socialMedia);
    console.log("====================================");
  };

  const handleView = (data) => {
    setSelectedRow(data);
    setShowRemarksModal(true);
  };



  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">Influencers Insights</h4>

          <div className="page-title-right">
            <Breadcrumbs />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="card" id="leadsList">
            <div className="row p-4 bg-light">
              <div className="bg-white rounded-4 p-4 shadow-sm">
                <div className="d-flex justify-content-between align-items-start mb-4">
                  <div>
                    <h4 className="fw-bold mb-1">Influencer Insight</h4>
                    <p className="text-muted mb-0">
                      Search an influencer profile to see their insights report
                    </p>
                  </div>

                  <a
                    href="export.html"
                    className="btn btn-danger px-4 py-3 rounded-3 fw-semibold"
                  >
                    BULK EXPORTS
                  </a>
                </div>

                <div className="input-group input-group-lg">
                  <Select
                    placeholder="Platform"
                    options={socialMediaOptions}
                    value={formData.socialMedia}
                    onChange={(selected) =>
                      handleChange("socialMedia", selected)
                    }
                    className="d-flex align-items-center gap-0 border-0 py-0"
                    styles={{
                      // padding: "0px 0px !important",
                      height: "1px",
                      marginTop: "5px",
                    }}
                  />

                  <input
                    type="text"
                    className="form-control py-0"
                    placeholder="Search Profile"
                    value={formData.searchValue}
                    onChange={(e) => handleChange("searchValue", e)}
                    style={{
                      // padding: "6px 10px !important",
                      height: "36px",
                      marginTop: "1px",
                    }}
                  />

                  <span
                    className="input-group-text bg-white p-0"
                    style={{
                      // padding: "0px 1px !important",
                      height: "36px",
                      marginTop: "1px",
                    }}
                  >
                    <button
                      className="btn btn-light h-100 rounded-right"
                      onClick={handleSearch}
                      type="button"
                      id="button-addon2"
                      style={{
                        padding: "0px 10px !important",
                        height: "34px !important",
                      }}
                    >
                      <i className="ri-arrow-right-line fs-4 text-muted"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card" id="leadsList">
                  <div className="card-header border-0">
                    <div className="row g-1 align-items-center">
                      <div className="col-sm-4">
                        <div className="dropdown">
                          <Select
                            placeholder="Platform"
                            options={socialMediaOptions}
                            value={formData.socialPlatform}
                            className="btn btn-light p-0"
                            onChange={(selected) =>
                              handleChange("socialPlatform", selected)
                            }
                          />
                        </div>
                      </div>
                      <div className="col-sm-auto ms-auto">
                        <div className="hstack gap-2">
                          <button className="btn btn-success add-btn" disabled>
                            <i
                              className="ri-download-2-line
                            align-bottom me-1"
                            ></i>{" "}
                            Download PDF
                          </button>
                          <a href="#" className="btn btn-success add-btn">
                            <i className="ri-download-2-line align-bottom me-1"></i>
                            Export Download XLSX
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      {/* LEFT SIDE */}
                      <div className="d-flex align-items-center gap-2">
                        <span>Show</span>

                        <select
                          className="form-select form-select-sm"
                          style={{ width: "80px" }}
                          value={entriesPerPage}
                          onChange={(e) => {
                            setEntriesPerPage(Number(e.target.value));
                            setCurrentPage(1);
                          }}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                        </select>

                        <span>entries</span>
                      </div>

                      {/* RIGHT SIDE */}
                      <div className="d-flex align-items-center gap-2">
                        <label className="mb-0">Search:</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          style={{ width: "200px" }}
                          placeholder="Search..."
                          value={searchTerm}
                          onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                          }}
                        />
                      </div>
                    </div>
                    <table className="table table-bordered align-middle">
                      <thead>
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              checked={
                                currentRows.length > 0 &&
                                currentRows.every((r) =>
                                  formData.selectedRows.includes(r.id)
                                )
                              }
                              onChange={(e) =>
                                handleChange("checkbox", null, {
                                  type: "all",
                                  checked: e.target.checked,
                                })
                              }
                            />
                          </th>
                          <th>SR No.</th>
                          <th>Influencer</th>
                          <th>Created At</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentRows.map((row, index) => (
                          <tr key={row.id}>
                            <td>
                              <input
                                type="checkbox"
                                checked={formData.selectedRows.includes(row.id)}
                                onChange={(e) =>
                                  handleChange("checkbox", null, {
                                    type: "row",
                                    id: row.id,
                                    checked: e.target.checked,
                                  })
                                }
                              />
                            </td>

                            <td> {((currentPage - 1) * entriesPerPage + index + 1)
                              .toString()
                              .padStart(2, "0")}</td>

                            <td>
                              <div className="d-flex align-items-center gap-3">
                                <img
                                  src={row.image}
                                  width="48"
                                  height="48"
                                  className="rounded-circle"
                                  style={{ objectFit: "cover" }}
                                />
                                <div>
                                  <strong>{row.username}</strong>
                                  <div className="text-muted">{row.name}</div>
                                </div>
                              </div>
                            </td>

                            <td>
                              {row.date}
                              <br />
                              {row.time}
                            </td>

                            <td>
                              <div className="d-flex align-items-center justify-content-around gap-2">
                                <button
                                  type="button"
                                  className="btn btn-success add-btn"
                                  onClick={() => handleView(row)}
                                >
                                  <i className="ri-arrow-right-up-line me-1"></i>{" "}
                                  VIEW
                                </button>

                                <div className="dropdown">
                                  <a href="#" data-bs-toggle="dropdown">
                                    <i className="ri-more-2-fill fs-5"></i>
                                  </a>
                                  <ul className="dropdown-menu">
                                    <li>
                                      <a className="dropdown-item" href="#">
                                        Download PDF
                                      </a>
                                    </li>
                                    <li>
                                      <a className="dropdown-item" href="#">
                                        Download XLSX
                                      </a>
                                    </li>
                                    <li>
                                      <a className="dropdown-item" href="#">
                                        Copy URL
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="row align-items-center mt-3">
                      <div className="col-sm-6">
                        Showing{" "}
                        <strong>
                          {totalItems === 0 ? 0 : indexOfFirstItem + 1}
                        </strong>{" "}
                        to{" "}
                        <strong>
                          {Math.min(indexOfLastItem, totalItems)}
                        </strong>{" "}
                        of <strong>{totalItems}</strong> entries
                      </div>

                      <div className="col-sm-6">
                        <ul className="pagination justify-content-end mb-0">
                          <li
                            className={`page-item ${currentPage === 1 ? "disabled" : ""
                              }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                setCurrentPage((p) => Math.max(p - 1, 1))
                              }
                            >
                              Previous
                            </button>
                          </li>

                          {Array.from({ length: totalPages }, (_, i) => (
                            <li
                              key={i}
                              className={`page-item ${currentPage === i + 1 ? "active" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setCurrentPage(i + 1)}
                              >
                                {i + 1}
                              </button>
                            </li>
                          ))}

                          <li
                            className={`page-item ${currentPage === totalPages ? "disabled" : ""
                              }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                setCurrentPage((p) =>
                                  Math.min(p + 1, totalPages),
                                )
                              }
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <button
              className="btn btn-danger mt-3"
              disabled={!formData.selectedRows.length}
              onClick={handleExport}
            >
              Export Selected
            </button> */}
          </div>
        </div>
      </div>
      <InsiteModal
        showRemarksModal={showRemarksModal}
        setShowRemarksModal={setShowRemarksModal}
        item={selectedRow} />
    </div>
  );
};

export default InfluencerInsights;
